<template>
  <div class="box" >

      <img class="logo1" src="../../assets/day1_slices/logo@2x.png" alt="" />
      <div class="name"></div>
      <div class="pc-left-white"></div>
      <img
        class="iphone-left"
        src="../../assets/day1_slices/组 7@2x.png"
        alt=""
      />
      <img
        class="iphone-right"
        src="../../assets/day1_slices/组 8@2x.png"
        alt=""
      />
      <img
        class="small-right"
        src="../../assets/day1_slices/球5@2x.png"
        alt=""
      />
      <img class="big-right" src="../../assets/day1_slices/球2@2x.png" alt="" />
      <div class="blue-left"></div>
      <div class="out-install">
        <div class="install" @click.stop="install">
          <span class="bag">安卓下载</span>
        </div>
        <div class="scan-code">
          <span class="bag">扫码下载</span>
        </div>
      </div>

      <div class="atomic-link">
        <p class="title">原子链钱包</p>
        <p class="desc">链接ATOSHI生态</p>
      </div>
      <div class="thread2">
        <div class="end-blue-right"></div>
      </div>
      <!-- 中英文切换 -->
      <div class="chinese-english">
                <div class="chinese">
          简体中文
        </div>
             <div class="english" @click="toEn">
          EN
        </div>

      </div>
      <!-- 移动端中英文切换 -->
      <div class="middle-chinese-english" @click="toEn">
        Switch to English
      </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  // data() {
  //   return {
  //     showflag: false,
  //   };
  // },
      inject: ["reload"],
  methods: {
    install() {
      //判断是否是微信浏览器或手机qq浏览器打开
      var u = navigator.userAgent
      let ua = navigator.userAgent.toLowerCase();
   var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      const isIosQQ = isIOS && / QQ/i.test(navigator.userAgent);
      const isAndroidQQ =
        isAndroid &&
        /MQQBrowser/i.test(navigator.userAgent) &&
        /QQ/i.test(navigator.userAgent.split("MQQBrowser"));

      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // this.showflag = !this.showflag;
        // this.$emit("showflag", this.showflag);
           this.reload();
         
      } else if (isIosQQ || isAndroidQQ) {
        // this.showflag = !this.showflag;
        // this.$emit("showflag", this.showflag);
           this.reload();
    
      } else {
        let testForm = document.createElement("form");
        testForm.setAttribute(
          "action",
          "https://game-img.atoshi.mobi/atoshiwallet/atoshiwallet.apk"
        );
        document.body.append(testForm);
        //提交表单，实现下载
        testForm.submit();
      
      }
     
    },
    toEn(){
      this.$router.push({
        name:"en"
      })

    }
  },
};
</script>
<style scoped lang="less">
.box {
  height: 100%;
  width: 100%;
}

@media screen and(max-width:750px) {
  .box {
    .middle-chinese-english{
      color:#d1e3f5;
      font-size:16px;
      position: absolute;
      top: 17px;
      right: 20px;
      line-height:26px;
    }
    .chinese-english{
      display: none;
    }
    // background: linear-gradient(20deg, #0034cb, #0e7dd7);
    .logo1 {
      width: 26px;
      height: 26px;
      position: absolute;
      top: 17px;
      left: 20px;
    }
    .scan-code {
      display: none;
    }
    .name {
      background: url("../../assets/day1_slices/名字@2x.png") no-repeat;
      width: 90px;
      height: 14px;
      background-size: contain;
      position: absolute;
      left: 48px;
      top: 23px;
    }
    .iphone-left {
      width: 153px;
      position: absolute;
      top: 170px;
      left: 66px;
      -webkit-animation: mobile-left 1.9s 0s 1 forwards;
      animation: mobile-left 1.9s 0s 1 forwards;
      z-index: 2;
    }
    // 左边手机
    @keyframes mobile-left {
      0% {
        -webkit-transform: translateY(55rem);
        transform: translateY(55rem);
        opacity: 0;
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
      }
    }
    .iphone-right {
      width: 151px;
      // height: 313px;
      position: absolute;
      top: 100px;
      right: 66px;
      z-index: 4;
      -webkit-animation: mobile-right 1.5s 0s 1 forwards;
      animation: mobile-right 1.5s 0s 1 forwards;
    }
    // 右边手机
    @keyframes mobile-right {
      0% {
        -webkit-transform: translateY(-55rem);
        transform: translateY(-55rem);
        opacity: 0;
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
      }
    }

    .small-right {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 230px;
      right: 23px;
      -webkit-animation: right-left2 1s 0s 1 forwards, ball-r-min 3s infinite 2s;
      animation: right-left2 1s 0s 1 forwards, ball-r-min 3s infinite 2s;
      box-shadow: 20px 30px 20px 0px rgba(3, 121, 200, 0.5);
      z-index: 1;
      border-radius: 50%;
      // opacity: 1;
    }
    // 右边白色小球出
    @keyframes right-left2 {
      0% {
        opacity: 1;
        -webkit-transform: translateX(4rem);
        transform: translateX(4rem);
      }
      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }
    // 右边白色小球动
    @keyframes ball-r-min {
      0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
      50% {
        -webkit-transform: translateY(-10px);
        transform: translateY(-10px);
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }

    .big-right {
      width: 208px;
      height: 208px;
      position: absolute;
      top: 227px;
      right: 0;
      z-index: 0;

      -webkit-animation: ball-r-max-init 1.4s 0s 1 forwards,
        ball-r-max 3s infinite 2s;
      animation: ball-r-max-init 1.4s 0s 1 forwards, ball-r-max 3s infinite 2s;
    }

    // 右边白色大球出来
    @keyframes ball-r-max-init {
      0% {
        opacity: 0;
        -webkit-transform: translateY(2rem);
        transform: translateY(2rem);
      }
      100% {
        opacity: 1;
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }
    // 右边白色大球上下动
    @keyframes ball-r-max {
      0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
      50% {
        -webkit-transform: translateY(10px);
        transform: translateY(10px);
      }

      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }

    .blue-left {
      width: 97px;
      height: 159px;
      position: absolute;
      top: 445px;
      // // left: -36px;
      left: 10px;
      background: url("../../assets/day1_slices/球3@2x.png") no-repeat -42px 0;
      background-size: cover;
      -webkit-animation: left-right 1.5s 0s 1 forwards,
        blue-left 4s infinite 1.5s;
      animation: left-right 1.5s 0s 1 forwards, blue-left 4s infinite 1.5s;
    }
    // 左边蓝球出来
    @keyframes left-right {
      0% {
        opacity: 1;
        -webkit-transform: translateX(-1.5rem);
        transform: translateX(-1.5rem);
      }
      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }
    // 左边蓝球动
    @keyframes blue-left {
      0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
      50% {
        -webkit-transform: translateY(-15px);
        transform: translateY(-15px);
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }

    .install {
      background: #fefefc;
      width: 150px;
      height: 37px;
      font-size: 16px;
      position: relative;
      left: 50%;
      margin-left: -75px;
      line-height: 37px;
      top: 521px;
      color: #000000;
      border-radius: 20px;
      vertical-align: bottom;
      &::before {
        width: 17px !important;
        height: 20px;
        position: absolute;
        left: 21px;
        top: 10px;
        background: url("../../assets/day1_slices/图层 11@2x.png") no-repeat;
        content: "";
        display: block;
        background-size: contain;
      }
      .bag {
        display: inline-block;
        position: absolute;
        left: 49px;
        top: 0;
      }
    }
    .atomic-link {
      position: absolute;
      top: 605px;
      left: 90px;
      // text-align: center;
      // line-height: 61px;
      color: #ffffff;
      .title {
        font-size: 38px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
      }
      .desc {
        // width: 147px;
        height: 19px;
        font-size: 20px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #ffffff;
        line-height: 32px;
        text-align: center;
      }
    }

    .thread2 {
      background: url("../../assets/day1_slices/纹理.png") no-repeat;
      width: 100%;
      height: 154px;
      background-size: 200% 100%;
      position: absolute;
      top: 680px;

      .end-blue-right {
        background: url("../../assets/day1_slices/球4@2x.png") no-repeat 23px 0;
        width: 91px;
        height: 103px;
        position: absolute;
        top: 14px;
        right: 10px;
        background-size: cover;
        -webkit-animation: right-left 1.6s 0s 1 forwards,
          ball-r-t 4s infinite 1.8s;
        animation: right-left 1.6s 0s 1 forwards, ball-r-t 4s infinite 1.8s;
      }

      // 最下面蓝色小球出来
      @keyframes right-left {
        0% {
          opacity: 1;
          -webkit-transform: translateX(1rem);
          transform: translateX(1rem);
        }
        100% {
          opacity: 1;
          -webkit-transform: translateX(0);
          transform: translateX(0);
        }
      }

      // 最下面蓝色小球上下动
      @keyframes ball-r-t {
        0% {
          -webkit-transform: translateY(0);
          transform: translateY(0);
        }
        50% {
          -webkit-transform: translateY(-15px);
          transform: translateY(-15px);
        }
        100% {
          -webkit-transform: translateY(0);
          transform: translateY(0);
        }
      }
    }
  }
}

@media screen and(min-width:750px) {
  .box {
    .middle-chinese-english{
      display: none;
    }
    // 中英文切换
    .chinese-english{
      position: absolute;
      top: 4px;
      right: 38px;
      line-height: 9px;
      font-size: 4.5px;
      color: #b7d4f1;
      width: 102PX;
      display: block;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
  
        font-family: Adobe Heiti Std;
            >div{
             cursor: pointer;
        position: relative;
        &:hover{
          color: #Fff;
        }
      }
          .chinese{
          &::after{
             width: 2px;
            height: 2px;
            background: #ffffff;
            border-radius: 50%;
            position: absolute;
            top: 10px;
            right: 0;
            display: block;
            content: '';
            left: 0;
            margin: auto;
           
          
          }
        }
        // .english{
        
        //   &::after{
        //     width: 2px;
        //     height: 2px;
        //     background: #ffffff;
        //     border-radius: 50%;
        //     position: absolute;
        //     top: 10px;
        //     right: 0;
        //       display: block;
        //     content: '';
        //       right: 0;
        //     left: 0;
        //     margin: auto;
        //   }
        // }
    }
    .logo1 {
      width: 9px;
      height: 9px;
      position: absolute;
      top: 4px;
      left: 29px;
    }
    .name {
      background: url("../../assets/day1_slices/名字@2x.png") no-repeat;
      width: 32px;
      height: 5px;
      background-size: contain;
      position: absolute;
      left: 39px;
      top: 6px;
    }
    // pc端多余的白色小球
    .pc-left-white {
      background: url("../../assets/day1_slices/球1@2x.png") no-repeat;
      width: 12px;
      height: 12px;
      position: absolute;
      background-size: contain;
      left: 22px;
      top: 35px;
      z-index: 1;
      -webkit-animation: pc-left-white 3.4s 0s 1 forwards,
        pc-white-left 4s infinite 3.4s;
      animation: pc-left-white 3.4s 0s 1 forwards,
        pc-white-left 4s infinite 3.4s;
    }
    @keyframes pc-left-white {
      0% {
        opacity: 1;
        -webkit-transform: translateX(-40px);
        transform: translateX(-40px);
      }
      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }
    // 左边蓝球动
    @keyframes pc-white-left {
      0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
      50% {
        -webkit-transform: translateY(-6px);
        transform: translateY(-6px);
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }

    .iphone-left {
      width: 60px;
      position: absolute;
      top: 58px;
      left: 215px;
      -webkit-animation: pc-left 1.9s 0s 1 forwards;
      animation: pc-left 1.9s 0s 1 forwards;
      z-index: 2;
    }
    // 左边手机
    @keyframes pc-left {
      0% {
        -webkit-transform: translateY(55rem);
        transform: translateY(55rem);
        opacity: 0;
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
      }
    }
    .iphone-right {
      width: 59px;
      position: absolute;
      top: 30px;
      left: 251px;
      z-index: 4;
      -webkit-animation: pc-right 1.5s 0s 1 forwards;
      animation: pc-right 1.5s 0s 1 forwards;
    }
    // 右边手机
    @keyframes pc-right {
      0% {
        -webkit-transform: translateY(-55rem);
        transform: translateY(-55rem);
        opacity: 0;
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
      }
    }
    //白色大球
    .big-right {
      width: 81px;
      height: 81px;
      position: absolute;
      top: 81px;
      left: 238px;
      z-index: 1;

      -webkit-animation: pc-ball-r-max-init 1.8s 0s 1 forwards,
        pc-ball-r-max 3s infinite 2s;
      animation: pc-ball-r-max-init 1.8s 0s 1 forwards,
        pc-ball-r-max 3s infinite 2s;
    }
    @keyframes pc-ball-r-max-init {
      0% {
        opacity: 0;
        -webkit-transform: translateY(2rem);
        transform: translateY(2rem);
      }
      100% {
        opacity: 1;
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }
    // 右边白色大球上下动
    @keyframes pc-ball-r-max {
      0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
      50% {
        -webkit-transform: translateY(3px);
        transform: translateY(3px);
      }

      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }
    // 左边的蓝色球
    .blue-left {
      width: 67px;
      height: 73px;
      position: absolute;
      bottom: 3px;
      left: -10px;
      z-index: 2;
      background: url("../../assets/day1_slices/球3@2x.png") no-repeat 0px 0;
      background-size: cover;
      -webkit-animation: pc-left-right 2s 0s 1 forwards,
        pc-blue-left 4s infinite 2.1s;
      animation: pc-left-right 2s 0s 1 forwards, pc-blue-left 4s infinite 2.1s;
    }
    // 左边蓝球出来
    @keyframes pc-left-right {
      0% {
        opacity: 1;
        -webkit-transform: translateX(-100px);
        transform: translateX(-100px);
      }
      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }
    // 左边蓝球动
    @keyframes pc-blue-left {
      0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
      50% {
        -webkit-transform: translateY(-10px);
        transform: translateY(-10px);
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }
    // 右边白色小球
    .small-right {
      width: 6px;
      height: 6px;
      position: absolute;
      top: 92px;
      left: 307px;
      -webkit-animation: pc-right-left2 1s 0s 1 forwards,
        pc-ball-r-min 3s infinite 2s;
      animation: pc-right-left2 1s 0s 1 forwards, pc-ball-r-min 3s infinite 2s;
      box-shadow: 4.5px 8px 5px 0.5px rgba(50, 121, 200, 0.7);
      z-index: 2;
      border-radius: 50%;
    }
    // 右边白色小球出
    @keyframes pc-right-left2 {
      0% {
        opacity: 1;
        -webkit-transform: translateX(4rem);
        transform: translateX(4rem);
      }
      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }
    // 右边白色小球动
    @keyframes pc-ball-r-min {
      0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
      50% {
        -webkit-transform: translateY(-3px);
        transform: translateY(-3px);
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }
    // 纹理图
    .thread2 {
      background: url("../../assets/day1_slices/纹理pc@2x.png") no-repeat;
      width: 100%;
      height: 60px;
      background-size: 100% 100%;
      position: fixed;
      bottom: 0;
      left: 0;
    }

    //右边的蓝色小球
    .end-blue-right {
      background: url("../../assets/day1_slices/球4@2x.png") no-repeat 0px 0;
      width: 32px;
      height: 35px;
      position: fixed;
      top: 45px;
      left: 343px;
      background-size: cover;
      z-index: 5;
      -webkit-animation: pc-right-left 1.7s 0s 1 forwards,
        pc-ball-r-t 4s infinite 1.7s;
      animation: pc-right-left 1.5s 0s 1 forwards, pc-ball-r-t 4s infinite 1.8s;
    }

    // 最下面蓝色小球出来
    @keyframes pc-right-left {
      0% {
        opacity: 1;
        -webkit-transform: translateX(1rem);
        transform: translateX(1rem);
      }
      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }

    // 最下面蓝色小球上下动
    @keyframes pc-ball-r-t {
      0% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
      50% {
        -webkit-transform: translateY(-6px);
        transform: translateY(-6px);
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
      }
    }

    //原子链文字
    .atomic-link {
      position: absolute;
      top: 55px;
      left: 62px;
      color: #ffffff;
      -webkit-animation: pc-font-size 2.4s 0s 1 forwards;
      animation: pc-font-size 2.4s 0s 1 forwards;
      z-index: 5;
      .title {
        font-size: 16px;
        // font-size: 61Px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        line-height: 24px;
        // line-height: 92.16Px;
      }
      .desc {
        // width: 147px;
        height: 7px;
        font-size: 8px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #ffffff;
        line-height: 12px;
        // text-align: center;
      }
    }
    @keyframes pc-font-size {
      0% {
        -webkit-transform: translateY(55rem);
        transform: translateY(55rem);
        opacity: 0;
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
      }
    }

    .out-install {
      position: relative;
        left: 63px;
        top: 100px;
      z-index: 2;
      -webkit-animation: pc-install 2.3s 0s 1 forwards;
      animation: pc-install 2.3s 0s 1 forwards;
      //安卓下载
      .install {
        background: #fefefc;
        width: 127Px;
        height: 31Px;
        position: relative;
        // left: 63px;
        // top: 100px;
        left:0;
        top: 0;
        color: #000000;
        border-radius: 20px;
        vertical-align: bottom;
          margin-right: 13px;
        &::before {
          width: 15Px;
          height:15Px;
          position: absolute;
          left: 19Px;
          top: 7Px;
          background: url("../../assets/day1_slices/图层 11@2x.png") no-repeat;
          content: "";
          display: block;
          background-size: contain;
        }
        .bag {
          font-size: 15Px;
          display: inline-block;
          position: absolute;
          left: 42Px;
          line-height: 31Px;
        }
      }
      .install:hover{
        cursor: pointer;
        background: rgba(255,255,255,.7);
      }
      //扫码下载
      .scan-code {
        background: #fefefc;
        width: 127Px;
        height: 31Px;
        position: absolute;
        // left:418Px;
        // top: 100px;
        left: 175Px;
        top: 0;
        color: #000000;
        border-radius: 20px;
        vertical-align: bottom;
        cursor: pointer;
        &::before {
          width: 15Px;
          height: 15Px;
          position: absolute;
          left: 19Px;
          top: 8.4Px;
          background: url("../../assets/day1_slices/图层 12@2x.png") no-repeat;
          content: "";
          display: block;
          background-size: contain;
          line-height: 30.7Px;
        }
        .bag {
          font-size: 15.3Px;
          display: inline-block;
          position: absolute;
          left: 42Px;
          line-height: 30.7Px;
        }
        &::after {
          background: url("../../assets/day1_slices/组 7@2x(1).png") no-repeat;
          position: absolute;
          left: 0px;
          top: 46Px;
          content: "";
          display: block;
          width: 0px;
          height:0px;
          background-size: cover;
       
        }
      }
      .scan-code:hover{
        background: rgba(255,255,255,.7);
        &::after{
          height: 172.7Px;
          width: 161.2Px;
          transition: all .3s linear;
        }
      }
      
    }
    @keyframes pc-install {
      0% {
        -webkit-transform: translateY(55rem);
        transform: translateY(55rem);
        opacity: 0;
      }
      100% {
        -webkit-transform: translateY(0);
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}
</style>